import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from './content.component';
import { ProjectsModule } from './projects/projects.module';
import { ContentRoutingModule } from './content-routing.module';
import { EmployeesModule } from './employees/employees.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'src/app/core/core.module';
import { NavbarComponent } from './navbar/navbar.component';
import { NavbarBodyComponent } from './navbar-body/navbar-body.component';
import { CrmModule } from './crm/crm.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LogoComponent } from 'src/app/core/components/logo/logo.component';
import { ForbiddenComponent } from '../forbidden/forbidden.component';
import { CompanySettingsModule } from './company-settings/company-settings.module';
import { AiAssistantWidgetDirective } from "src/app/core/directives/ai-assistant-widget.directive";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    CoreModule,
    ContentRoutingModule,
    ProjectsModule,
    EmployeesModule,
    CrmModule,
    CompanySettingsModule,
    LogoComponent,
    AiAssistantWidgetDirective
],
  declarations: [
    ContentComponent,
    NavbarComponent,
    NavbarBodyComponent,
    ForbiddenComponent
  ],
  exports: [ContentComponent],
})
export class ContentModule {}
